import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Select } from 'antd';

import SxIcon from './sxIcon';
import { SIMPLE, DEFAULT } from './antdDropdownTypes';

import styles from './antdDropdown.module.scss';

class antdDropdown extends Component {
  renderSuffixIcon() {
    const { type, suffixIcon, caretClassName } = this.props;
    if (suffixIcon) {
      return suffixIcon;
    }

    if (type === SIMPLE) {
      return <SxIcon name="sx-icon-down" className={cx(styles.caret, styles.simple, caretClassName)} noFloat />;
    }

    return <SxIcon name="sx-down" className={cx(styles.caret, caretClassName)} noFloat />;
  }

  isBordered() {
    const { type, bordered } = this.props;
    if (bordered) {
      return bordered;
    }

    return type !== SIMPLE;
  }

  render() {
    const { children, className, dropdownClassName, caretClassName: _, ...props } = this.props;

    return (
      <Select
        {...props}
        className={cx(className, styles.dropdown)}
        suffixIcon={this.renderSuffixIcon()}
        dropdownClassName={cx(dropdownClassName, styles.menu)}
        bordered={this.isBordered()}
      >
        {children}
      </Select>
    );
  }
}

antdDropdown.defaultProps = {
  type: DEFAULT,
};

antdDropdown.propTypes = {
  className: PropTypes.string,
  dropdownClassName: PropTypes.string,
  caretClassName: PropTypes.string,
  type: PropTypes.oneOf([SIMPLE, DEFAULT]),
};

export default antdDropdown;
